import $ from 'jquery';
import Instafeed from 'instafeed.js';
import 'bxslider';

const setInstagram = (MYAPP) => {
  let $gallery = $('#insta-gallery');
  if ($gallery.length < 1) { return; }

  const sliderConfig = {
    pc: {
      ticker: true,
      speed: 100000,
      minSlides: 3,
      maxSlides: 10,
      slideWidth: 250,
      controls: false,
      pager: false,
      useCSS:false
    },
    sp: {
      speed: 500,
      minSlides: 3,
      maxSlides: 5,
      moveSlides: 2,
      slideWidth: 150,
      slideMargin: 0,
      controls: false,
      pager: false,
      swipeThreshold: 50,
      preventDefaultSwipeY: false,
      useCSS:false
    }
  };

  const commonArgs = {
    target: 'insta-gallery',
    get: 'user',
    userId: "2871302983",
    clientId: "100761feb26d4c0392e70a1aaa562af7",
    accessToken: "2871302983.100761f.ea59e3531d2a4190893a8d0c51cabab4"
  };

  let args = {
    pc: {
      target: commonArgs.target,
      get: commonArgs.get,
      userId: commonArgs.userId,
      clientId: commonArgs.clientId,
      accessToken: commonArgs.accessToken,
      limit: 12,
      links: true,
      resolution: 'low_resolution',
      template: '<div><a href="{{link}}" target="_blank"><img src="{{image}}" alt=""></a></div>',
      after: function() {
        $gallery.bxSlider(sliderConfig.pc);
      }
    },
    sp: {
      target: commonArgs.target,
      get: commonArgs.get,
      userId: commonArgs.userId,
      clientId: commonArgs.clientId,
      accessToken: commonArgs.accessToken,
      limit: 9,
      links: true,
      template: '<div><a href="{{link}}" target="_blank"><img src="{{image}}" alt=""></a></div>',
      after: function() {
        $gallery.bxSlider(sliderConfig.sp);
      }
    }
  };


  if ($gallery.html() !== '') {
    $('.insta-gallery-wrap').empty().html('<div class="insta-gallery" id="insta-gallery"></div>');
    $gallery = $('#insta-gallery');
  }

  args.now = (MYAPP.isMobile) ? args.sp : args.pc;

  const feed = new Instafeed(args.now);
  feed.run();
};

const setGoogleMap = () => {
  const mapLat = 35.62509,
    mapLng = 140.05337,
    icon   = 'assets/images/top/icon-map01.png',
    center = {
      lat: mapLat,
      lng: mapLng
    };

  const map = new google.maps.Map(document.getElementById('map'), {
    center: center,
    zoom: 14,
    scrollwheel: false,
    mapTypeControlOptions: {
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
    }
  });

  const marker = new google.maps.Marker({
    position: center,
    map: map,
    icon: icon
  });

  const styleOptions = [
    {
      "stylers": [
        { "saturation": -100 }
      ]
    },{
      "featureType": "transit.line",
      "stylers": [
        { "visibility": "simplified" }
      ]
    },{
      "featureType": "administrative.locality",
      "stylers": [
        { "visibility": "off" }
      ]
    }
  ];
  const styledMap = new google.maps.StyledMapType(styleOptions, {name: "The Surf"});

  map.mapTypes.set('map_style', styledMap);
  map.setMapTypeId('map_style');
};

module.exports = {
  setInstagram : setInstagram,
  setGoogleMap : setGoogleMap
};



// WEBPACK FOOTER //
// ./src/js/modules/top.js